module.exports = __webpack_public_path__ + "img/FY24_JMSA_SpringPassSales_640x298.jpg";